<template lang="pug">

.etapa-analise-prada(v-if='etapaPRADA')

    .linha
        b.coluna(style='margin-bottom: 12px') PRADA - Projeto de Recomposição de Áreas Degradadas e Alteradas

    .linha
        b.coluna Número do PRADA

    .linha
        .coluna
            subtitle-component(:label='etapaPRADA.numeroPRADA')

    .linha
        .coluna
            collapse-component(title='Requerentes ou Interessados', :isBasic='true')

                template(v-if='etapaPRADA.requerentes?.length > 0')

                    collapse-component(
                        v-for='(requerente, i) in etapaPRADA.requerentes',
                        :key='i',
                        :title='"Requerente: " + requerente.nome'
                    ).content(:style='{ marginBottom: "30px" }')

                        .linha(:style='[{ display: "flex" }, { alignItems: "flex-start" }]')

                            .coluna
                                .linha
                                    b.coluna Nome:
                                .linha
                                    .coluna {{ requerente.nome }}

                                .linha
                                    b.coluna {{ isCNPJ(requerente.cpf) ? 'CNPJ:' : 'CPF:' }}
                                .linha
                                    .coluna {{ requerente.cpf }}

                            .coluna
                                .linha
                                    b.coluna Avaliação:
                                .linha
                                    .coluna
                                        validacao-component(
                                            :tipo='requerente.nome',
                                            :item='requerente',
                                            :tipos-documentos='tiposDocumentos',
                                        )

                template(v-else)

                    .linha
                        .coluna Nenhum requerente informado.

    //- Compromissários
    .linha(v-if='compromissarios.length > 0')
        .coluna
            collapse-component(title='Compromissários', :isBasic='true')

                collapse-component(
                    v-for='(compromissario, i) in compromissarios',
                    :key='i',
                    :title='"Compromissário(a): " + compromissario.nome'
                ).content(:style='{ marginBottom: "30px" }')

                    .linha(:style='[{ display: "flex" }, { alignItems: "flex-start" }]')

                        .coluna
                            .linha
                                b.coluna Nome:
                            .linha
                                .coluna {{ compromissario.nome }}

                            .linha
                                b.coluna {{ isCNPJ(compromissario.cpf) ? 'CNPJ:' : 'CPF:' }}
                            .linha
                                .coluna {{ compromissario.cpf }}

                            .linha
                                b.coluna Endereço:
                            .linha
                                .coluna {{ compromissario.endereco }}

                            .linha
                                b.coluna CEP:
                            .linha
                                .coluna {{ compromissario.cep }}

                            .linha
                                b.coluna Município:
                            .linha
                                .coluna {{ compromissario.municipio }}

                        .coluna
                            .linha
                                b.coluna Endereço eletrônico:
                            .linha
                                .coluna {{ compromissario.email }}

                            .linha
                                b.coluna Telefone:
                            .linha
                                .coluna {{ compromissario.telefone }}

                            .linha(v-if='compromissario.urlProcuracao')
                                .coluna
                                    button-component(
                                        label='Download Procuração',
                                        icon='mdi-download',
                                        background-color='#ddd',
                                        color='#666',
                                        @click.native='downloadProcuracao(compromissario.urlProcuracao)',
                                    )

                        .coluna
                            .linha
                                b.coluna Avaliação:
                            .linha
                                .coluna
                                    validacao-component(
                                        :tipo='compromissario.nome',
                                        :item='compromissario',
                                        :tipos-documentos='tiposDocumentos',
                                    )

    //- Representantes Legais
    .linha(v-if='representantesLegais.length > 0')
        .coluna
            collapse-component(title='Representante(s) Legal(is)', :isBasic='true')

                collapse-component(
                    v-for='(representante, i) in representantesLegais',
                    :key='i',
                    :title='"Representante Legal: " + representante.nome'
                ).content(:style='{ marginBottom: "30px" }')

                    .linha(:style='[{ display: "flex" }, { alignItems: "flex-start" }]')

                        .coluna
                            .linha
                                b.coluna Nome:
                            .linha
                                .coluna {{ representante.nome }}

                            .linha
                                b.coluna {{ isCNPJ(representante.cpf) ? 'CNPJ:' : 'CPF:' }}
                            .linha
                                .coluna {{ representante.cpf }}

                            .linha
                                b.coluna Endereço:
                            .linha
                                .coluna {{ representante.endereco }}

                            .linha
                                b.coluna CEP:
                            .linha
                                .coluna {{ representante.cep }}

                            .linha
                                b.coluna Município:
                            .linha
                                .coluna {{ representante.municipio }}

                        .coluna
                            .linha
                                b.coluna Endereço eletrônico:
                            .linha
                                .coluna {{ representante.email }}

                            .linha
                                b.coluna Telefone:
                            .linha
                                .coluna {{ representante.telefone }}

                            .linha(v-if='representante.urlProcuracao')
                                .coluna
                                    button-component(
                                        label='Download Procuração',
                                        icon='mdi-download',
                                        background-color='#ddd',
                                        color='#666',
                                        @click.native='downloadProcuracao(representante.urlProcuracao)',
                                    )

                        .coluna
                            .linha
                                b.coluna Avaliação:
                            .linha
                                .coluna
                                    validacao-component(
                                        :tipo='representante.nome',
                                        :item='representante',
                                        :tipos-documentos='tiposDocumentos',
                                    )

    .linha(v-if='representantesLegais.length === 0 && compromissarios.length === 0')
        .coluna
            collapse-component(title='Compromissários', :isBasic='true')
                .linha
                    .coluna Nenhum compromissário informado.

    .linha
        .coluna
            collapse-component(title='Responsável Técnico', :isBasic='true')

                .linha
                    .coluna
                        .responsaveis(v-if='etapaPRADA?.responsaveisTecnicos?.length > 0')

                            collapse-component(
                                v-for='(responsavel, i) in etapaPRADA.responsaveisTecnicos',
                                :key='i',
                                :title='"Responsável: " + responsavel.nome'
                            ).content(:style='{ marginBottom: "30px" }')

                                .linha(:style='[{ display: "flex" }, { alignItems: "flex-start" }]')

                                    .coluna
                                        .linha
                                            b.coluna Nome:
                                        .linha
                                            .coluna {{ responsavel.nome }}

                                        .linha
                                            b.coluna CPF:
                                        .linha
                                            .coluna {{ responsavel.cpf }}

                                        .linha
                                            b.coluna Endereço:
                                        .linha
                                            .coluna {{ responsavel.endereco }}

                                        .linha
                                            b.coluna CEP:
                                        .linha
                                            .coluna {{ responsavel.cep }}

                                        .linha
                                            b.coluna Município:
                                        .linha
                                            .coluna {{ responsavel.municipio }}

                                    .coluna
                                        .linha
                                            b.coluna Endereço eletrônico:
                                        .linha
                                            .coluna {{ responsavel.email }}

                                        .linha(v-if='responsavel.formacaoProfissional')
                                            b.coluna Formação profissional:
                                        .linha
                                            .coluna {{ responsavel.formacaoProfissional }}

                                        .linha(v-if='responsavel.registroConselhoClasse')
                                            b.coluna N° de registro no conselho de classe:
                                        .linha
                                            .coluna {{ responsavel.registroConselhoClasse }}

                                    .coluna
                                        .linha
                                            b.coluna Avaliação:
                                        .linha
                                            .coluna
                                                validacao-component(
                                                    :tipo='responsavel.nome',
                                                    :item='responsavel',
                                                    :tipos-documentos='tiposDocumentos',
                                                )

                        .sem-responsavel(v-else)
                            .linha
                                .coluna Não possui responsável técnico.

    .linha
        .coluna
            collapse-component(
                title='Projeto para áreas aguardando recomposição/regeneração',
                :isBasic='true'
            )
                PradaAreasRecompRegTable(
                    :areas='etapaPRADA?.projetosArea',
                    :tiposDocumentos='tiposDocumentos',
                )

    .linha
        .coluna
            collapse-component(title='Cronograma', :isBasic='true')
                PradaCronogramaTable(
                    :cronogramas='etapaPRADA?.cronogramas',
                    :tiposDocumentos='tiposDocumentos',
                )

</template>

<script>

import {
    buscarEtapaPRADA,
    salvar,
    downloadProcuracao
} from '@/services/etapa-prada.service';

import PradaAreasRecompRegTable from '@/views/analise/components/etapaPRADA/PradaAreasRecompRegTable.vue';
import PradaCronogramaTable from '@/views/analise/components/etapaPRADA/PradaCronogramaTable.vue';
import ValidacaoComponent from '@/views/analise/components/ValidacaoComponent.vue';

export default {

    name: 'EtapaPRADA',

    components: {
        PradaAreasRecompRegTable,
        PradaCronogramaTable,
        ValidacaoComponent
    },

    props: {
        tiposDocumentos: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            idProcesso: this.$route.params.id,
            etapaPRADA: null,
        };
    },

    computed: {

        representantesLegais() {
            return this.etapaPRADA?.compromissarios?.filter(
                compromissario => compromissario.representanteLegal === true
            ) ?? [];
        },

        compromissarios() {
            return this.etapaPRADA?.compromissarios?.filter(
                compromissario => compromissario.representanteLegal !== true
            ) ?? [];
        },

    },

    async mounted() {

        try {

            const response = await buscarEtapaPRADA(this.idProcesso);

            if (!response) {

                this.etapaPRADA = {
                    numeroPRADA: '',
                    requerentes: [],
                    compromissarios: [],
                    responsaveisTecnicos: [],
                    projetosArea: [],
                    cronogramas: [],
                    processo: null
                };

            } else {

                this.etapaPRADA = {
                    ...response,

                    projetosArea: (response.projetosArea || []).map(e => ({
                        ...e,

                        acao: [
                            {
                                id: 'WEBAMBIENTE',
                                label: 'Sugestão webambiente',
                                icon: 'mdi-earth'
                            },
                            {
                                id: 'VISUALIZAR',
                                label: 'Visualizar dados',
                                icon: 'mdi-magnify'
                            }
                        ]
                    }))
                };

            }

        } catch {

            this.$router.push({ name: 'analise-proposta' });

        }

    },

    methods: {

        isCNPJ(doc) {

            if (!doc) return false;

            const digits = String(doc).replace(/\D/g, '');

            return digits.length === 14;
        },

        async salvar() {

            const processo = await salvar(this.idProcesso, this.etapaPRADA);

            if (processo) {

                this.$toast({
                    showClose: true,
                    message: 'Informações salvas com sucesso!',
                    type: 'success'
                });

                return processo;

            } else {

                return this.etapaPRADA.processo;

            }

        },

        getCronogramaSeries(cronogramas) {

            let seriesData = [];

            cronogramas.forEach((cronograma) => {

                seriesData.push({
                    x: cronograma.projeto,
                    y: [
                        new Date(cronograma.inicio).getTime(),
                        new Date(cronograma.inicio).getTime(),
                    ],
                    fillColor: "#" + Math.floor(Math.random() * 16777215).toString(16)
                });

            });

            window.dispatchEvent(new Event('resize'));

            return seriesData;
        },

        async downloadProcuracao(path) {

            const documento = await downloadProcuracao({
                nome: '',
                url: path
            });

            const extFile = documento.data.type === 'application/pdf'
                ? 'pdf'
                : 'jpg';

            const file = window.URL.createObjectURL(
                new Blob(
                    [documento.data],
                    { type: documento.data.type }
                )
            );

            var docUrl = document.createElement('a');

            docUrl.href = file;

            docUrl.setAttribute(
                'download',
                'procuracao_compromissario.' + extFile
            );

            document.body.appendChild(docUrl);

            docUrl.click();
        },

    },

};

</script>

<style scoped>

.titulo {
    padding: 40px 0px;
    font-weight: 600;
    font-size: 14px;
    color: var(--primary-black);
}

.mapa-iara {
    margin-right: 15px;
    color: var(--primary-black) !important;
}

.recomposicoes-map {
    padding: 15px;
    max-height: 500px;
}

.button-left {
    margin-right: 15px;
    padding: 0px 8px;
}

.documento-iara {
    color: var(--primary-green) !important;
}

.link {
    color: -webkit-link;
    cursor: pointer;
    text-decoration: underline;
}

.divisor {
    border-bottom: 1px solid var(--primary-dark-smoke);
    margin: 50px 0px 30px 0px;
}

</style>